import { Time } from "@angular/common";
import { Style } from "exceljs";
import { Data } from "popper.js";
import { AirItinerary, AirPricingSolution, typeBaseAirSegment } from "./AirPricingSolutionProperties";
import { AirSegmentsDetailsNew, FlightSchedulesNew } from "./flight-results-response-properties";
import { BookingBasicProperties, FlightSearchProperties, PriceCardDetails } from "./FlightSearchProperties";
import { AgencyWiseFareCalculations, BaseFlightDetails, PassengerFares, Seatobject, Ssr } from "./FlightSearchResponseProperties";
import { AvailablePaxSSRList, SeatAvailabilityResponse } from "./spice-properties";




export class BookingInfoProperties {
  currencyRateByDefault: number;
  currencyCriteriaThatApplied: string;
  revenueApplied: string;
  bookingID: number;
  exchangebookingId: string;
  exchangeIssuanceDateTime: Date;
  creationTime: Time;
  bookingDate: Date;
  issuanceDateTime: Date;
  bookingStatus: number;
  exchangedBookingStatus: number;
  refundDateTime: Date;
  voidDateTime: Date;
  pnr: string;
  finalBuyerID: string;
  modifiedDateTime: Date;
  creationUser: number;
  issuanceUser: number;
  issuanceAgency: string;
  bookingPassengerInfoProperties: BookingPassengerInfoProperties[] = [];
  exchangebookingPassengerInfoProperties: BookingPassengerInfoProperties[] = [];
  supplier: string = "";
  bookingbasicsInfo: BookingBasicProperties;
  universalLocator: string;
  providerReservationInfo: string;
  supplierLocatorCode: string;
  airReservationLocator: string;
  providerCode: string;
  pricingSolution: object;
  bookingAgency: string;
  offlineRequest: boolean;
  extraMarkup: number;
  galileoBookingProp: GalileoBookingProp;
  supplierAirPricingSolution: string;
  suppliersRemarks: string;
  lastTicketingTime: string;
  pendingcredits: number = 0;
  creditslimit: number = 0;
  totalAmount: number = 0;
  SpicePaidAmount: number = 0;
  totalrefundAmount: number = 0;
  passengerFares: PassengerFares[] = [];
  supplierCommisionRule: number = 0;
  brandAirArabia: boolean;
  transactionIdentifierJ: string;
  modifypricingSolution: object;
  flightProp: FlightSearchProperties;
  selectedBrand1: number = 0;
  selectedBrand2: number = 0;
  returnflightAirArabia: boolean;
  parentHierarchy: string;
  userBackSystemCustomer: string = "";
  userBackSystemCompanyId: number = 0;
  backCompanyUserId: number = 0;
  cancelBookingUser: number = 0;
  anciHititIssue: AnciHititSectionForIssueSSR;

  groupTicketId: number = 0;
  groupTicketRequest: number = 0;
  exchangeCheck: any;
  extraServiceCharges: number;
  totalrefundAmountCustomer: number;
  dueDate: Date;
  flightlocationInfoDBSave: string;
  exchangeDivideCheck: any;
  anciSelected: boolean = false;
  flightSchedule = new FlightSchedulesNew();
  alreadyPriced: boolean;
  originDestinationDetails: string;
  isImportPnr: boolean = false;
  isInvoicePostedForImportPnr: boolean = false;
}

export class AnciHititSectionForIssueSSR {
  anciHitit: boolean = false;
  ssrIssue: boolean = false;
  totalIssueAmount: number;
  currencyValue: number;
}
export class AssociatedAdultwithInfantList {
  adultName: string = "";
  adultfirstName: string = "";
}
export class GalileoBookingProp {
  supplier: string = "";
  flightProp: FlightSearchProperties;
  priceCardDetails: PriceCardDetails[] = [];
  airSegments: AirSegmentsDetailsNew[] = [];
}
export class BookingPassengerInfoProperties {
  paxRemFrmBkng: boolean = false;
  passengerType: number;
  passengerID: number = 0;
  title: string;
  passengerName: string;
  firstName: string;
  lastName: string;
  paxGender: string;
  paxNationality: string;
  paxIsLead: boolean;
  passportNumber: string;
  countryOfIssuance: string;
  passportValidFrom: Date;
  passportValidTo: Date;
  serviceType: number;
  serviceSubType: number;
  //ffNo: string = "";
  mobile: string;
  mobileSecondary: string;
  phone: string;
  email: string;
  pnR_Doc: string;
  ticketNo: string;
  tktBookingDate: Date;
  travelingDate: string;
  sector: string;
  supplierCode: string;
  iATACode: number;
  airlineCode: string;
  tripType: string;
  conj_Option: boolean;
  conj_TktNo: string;
  exchange_TktNo: string;
  exchange_Option: boolean;
  exchange_TktFee: number;
  debitStatus: number;
  paymentMode: number;
  bookingID: string;
  issuanceID: string;
  bookingPccCode: string;
  issuancePccCode: string;
  itineraryNo: string;
  iATAInvoiceNo: string;
  mainSupplierID: string;
  sellerID: string;
  buyerID: string;
  costFromAmount: number;
  costFromCurrency: number;
  costExchangeRate: number;
  baseCurrency: string;
  exchangeCurrency: string;
  baseFare: number;
  totalTaxes: number;
  markup: number;
  netFromCustomer: number;
  netToSupplier: number;
  region: string;
  bookingInfoID: number;
  modifiedDateTime: Date;
  supplierRemarks: string;
  isVoid: boolean;
  sectorInformationProperties: SectorInformationProperties[] = [];
  taxDetailsProperties: TaxDetailsProperties[] = [];
  isChecked: boolean;
  frequent_Flyer_No: string;
  profile_Id: number;
  pDOB: string;
  pExpirypp: string;
  serviceCharges: number;
  discount: number;
  runtimeMarkup: number;
  isRefund: boolean = false;
  disabledrefund: boolean = false;
  isOfflineVoid: boolean;
  isOfflineRefund: boolean;
  typeName: string;
  paxCount: string;
  refundAmount: number = 0;
  netRefundAmount: number = 0;
  refundServiceCharges: number = 0;
  paxdob: Date;
  cnic: string = "";
  associatedAdult: string = "";
  backSystemServiceId: number = 0;
  refundTicketServiceDetails: RefundTicketProperties;
  venderServiceCharges: number = 0;
  supplierCommission: number = 0;
  supplierVatInput: number = 0;
  customerVatInput: number = 0;
  vatInput: number = 0;
  customerVatOutput: number = 0;
  supplierVatOutput: number = 0;
  vatOutput: number = 0;
  additionalServiceCharges: number = 0;
  commissionOffer: number = 0;
  interBranchCharges: number = 0;
  backSystemCustomerCompanyId: number = 0;
  currencySupplier: string;
  //pnR_Doc: string;

  groupTicketId: number = 0;
  modifyAdditionalServiceCharges: number = 0;
  dob: string = "";
  psdatevalid: string = "";
  netToSupplierRefund: number = 0;
  netRefundAmountCustomer: number = 0;
  refundServiceChargesCustomer: number = 0;
  refundAmountCustomer: number = 0;
  refundPenalty: number = 0;
  refundPenaltyCustomer: number = 0;
  offlineIssuanceBaseFare: number = 0;
  offlineIssuanceTotalTaxes: number = 0;
  offlineIssuanceVSCharges: number = 0;
  offlineIssuanceDiscount: number = 0;
  offlineIssuanceCommissionOff: number = 0;
  offlineIssuanceSupplier: string = "";
  offlineIssuancePccCode: string = "";
  offlineIssuancePccIATA: string = "";
  offlineIssuancePccCurrency: string = "";
  isOfflineIssuanceRequest: boolean = false;
  offlineIssuanceExchangeRate: number = 1;
  isDeleted: boolean;
  bookingStatus: string;
  selectedForModify: boolean;
  telephoneList = new TelephonePassengerProperties();
  telephoneListSecondary = new TelephonePassengerProperties();
  firstNameShow: string;
}
export class TelephonePassengerProperties {
  countryAccessCode: string = "";
  areaCityCode: string = "";
  phoneNumber: string = "";
  country: string = "";
  flag: string = "";
  city: string = "";
  mask: string = "";
}
export class RefundTicketProperties {
  refundServiceID: number = 0;
  serviceDetailsId: number = 0;
  refundExchangeFee: number = 0;
  refundFareValue: number = 0;
  refundTaxValue: number = 0;
  refundVenderServiceCharges: number = 0;
  refundSupplierCommission: number = 0;
  refundCustVatInput: number = 0;
  refundSupplierVatInput: number = 0;
  refundVatInput: number = 0;
  refundServiceCharges: number = 0;
  refundDiscount: number = 0;
  refundAdditionalServiceCharges: number = 0;
  refundCommissionOffer: number = 0;
  refundProfit: number = 0;
  refundCustVatOutput: number = 0;
  refundSupplierVatOutput: number = 0;
  refundVatOutput: number = 0;
  refundPenality: number = 0;
  netFromSupplier: number = 0;
  netToCustomer: number = 0;
  refundInterBranchCharges: number = 0;
  refundProvisionAmount: number = 0;
  refundOrderId: number = 0;
  refundOperationServiceCharges: number = 0;
  refundOperationAdditionalServiceCharges: number = 0;
  refundInterBranchSC: number = 0;
  refundOperationServiceCh_VatOutput: number = 0;
  refundRoundingDifference: number = 0;
}
export class SectorInformationProperties {
  id: number = 0;
  passengerID: number;
  modifiedDateTime: Date;
  airlineName: string;
  airlineLogo: string;
  fromAirport: string;
  toAirport: string;
  fromAirportName: string;
  toAirportName: string;
  fromCity: string;
  toCity: string;
  rbd: string;
  cabinClass: string;
  airlineCode: string;
  operatingAirlineCode: string;
  validatingAirlineCode: string;
  flightNumber: string;
  flightStatus: string;
  departureDate: Date;
  departureTime: string;
  arrivalDate: Date;
  arrivalTime: string;
  fareBasisCode: string;
  aircraft: string;
  stopOverIndicator: string;
  noOfStops: number;
  stopsAt: string;
  departureTerminal: string;
  arrivalTerminal: string;
  flownMile: number;
  ticketDesignator: string;
  frequentFlyerNo: string;
  frequentFlyerMiles: number;
  segmentValue: number;
  fuelSurchargeAmount: number;
  currencyCode: string;
  baggageCheckIn: string;
  baggageCabin: string;
  isDeleted: boolean;
  isRefunded: boolean;
  refundID: number;
  airlinePrefixCode: string;
  meal: string = "";
  mealname: string = "";
  seatNumber: string = "";
  seatkey: string;
  seatFee: number = 0;
  mealFee: number = 0;
  baggageFee: number = 0;
  baggagename: string = "";
  mealListBysector: MealListAirArabia[] = [];
  seatListBysector: RowWiseSeatProperties[] = [];
  fzMealList: FZMealList[] = [];
  fzBaggageList: FZBaggageList[] = [];
  generalListSpice: AvailablePaxSSRList[] = [];
  seatListSpice: SeatAvailabilityResponse;
  baggageCode: string = "";
  baggageDescription: string = "";
  mealListJ: Ssr[] = [];
  seatListJ: Seatobject;
  seatli: string;
  generalListJ: Ssr[] = [];
  baggListJ: Ssr[] = [];
  baggaesBysector: BaggageListAirArabia[] = [];
  baggagebtn: boolean = false;
  brandsselected: boolean = false;
  flightIndex: number = 0;
  checksectorHitit: boolean = false;
  checksectorHititbag: boolean = false;

  ssrObj: AdditionalBaggageRequiredObj;
  seatListBysectorExec: RowWiseSeatProperties[] = [];
  extraBagCheckIn: string;
  seatsectionAirplane: string[] = [];
  seatsectionAirplaneExec: string[] = [];
  mealRemReq: boolean = false;
  bagRemReq: boolean = false;
  seatRemReq: boolean = false;
  fzSeatList: string = "";
  seatListBysectorResponsive: SectorWiseSeatProperties;
  seatExec: boolean = false;
  seatEco: boolean = false;
  uniqueIndex: number = 0;
  anciButton: boolean = false;

  seatbtn: boolean = false;
  mealbtn: boolean = false;
    airlineLogoTicket: any;
}
export class SectorWiseSeatProperties {
  rows: RowWiseSeatProperties[] = [];
  dynamicSeatsWithRowsExec = new DynamicSeatsWithRows();
  dynamicSeatsWithRowsEco = new DynamicSeatsWithRows();
  fromCity: string = "";
  toCity: string = "";
    economySeatAvail: boolean;

}
export class ModifyDataCarry {

  modifyCarry: string = "";
}
export class ANCIHititFareBreakDownProperties {
  pstype: string = "";
  pscount: number = 0;
  seatFee: number = 0;
  baggageFee: number = 0
  totalAmount: number = 0;
  totalamountwithanci: number = 0;
}
export class PassengerMealBaggageProperties {
  fromCity: string = "";
  toCity: string = "";
  passengerName: string = "";
  meal: string = "";
  baggage: string = "";
}
export class FZMealList {
  offerID: number = 0;
  offerCode: string = "";
  amountActive: boolean = true;
  description: string = "";
  ruleId: string = "";
  currency: string = "";
  amount: number = 0;
  totalAmount: number = 0;
  paxIDs: number[] = []
  groupedFltIDs: string[] = [];
  //public List<Fee> fees = new List<Fee>();
  //public List<Tax> taxes = new List<Tax>();
  //public List<Seat> seats = new List<Seat>();
  quantityAvailable: number = 0;
  hashCode: string = "";
  cabin: string = "";
}

export class FZBaggageList {
  offerID: number = 0;
  offerCode: string = "";
  amountActive: boolean = true;
  description: string = "";
  ruleId: string = "";
  currency: string = "";
  amount: number = 0;
  totalAmount: number = 0;
  paxIDs: number[] = []
  groupedFltIDs: string[] = [];
  //public List<Fee> fees = new List<Fee>();
  //public List<Tax> taxes = new List<Tax>();
  //public List<Seat> seats = new List<Seat>();
  quantityAvailable: number = 0;
  hashCode: string = "";;
  cabin: string = "";
}


export class MealAirArabiaProperties {
  sectormeals: SectorWiseMealProperties[] = [];
  sectorbaggage: SectorWiseBaggageProperties[] = [];
  seatbysector: SectorWiseSeatProperties[] = [];
  availiable: boolean;
  error: string;
  byDefaultCurrencyRate: number = 0;
  currencyCriteriaThatApplied: string = "";
}

export class BaggageSectorsInformationList {
  fromCity: string = "";
  toCity: string = "";
  baggageavailiable: boolean = false;
}

export class RowWiseSeatProperties {
  rowNumber: string
  seats: SeatListAirArabia[] = [];


}

export class DynamicSeatsWithRows {
  seatSection: string[] = [];
  rows: RowWiseSeatProperties[] = [];
}

export class SeatListAirArabia {
  seatCode: string = "";
  seatCharge: string = "";
  rowNumber: string = "";
  seatStatus: string = "";
  seatKey: string;
}
export class SectorWiseBaggageProperties {
  baggages: BaggageListAirArabia[] = [];
  sectorinfolist: BaggageSectorsInformationList[] = [];;
  ssrObj: AdditionalBaggageRequiredObj;

}
export class AdditionalBaggageRequiredObj {
  code: string = "";
  Explaination: string = "";
  ssrgroupExplaination: string = "";
  ssrgroupcode: string = "";
}

export class BaggageListAirArabia {
  baggageCode: string = "";
  baggageDescription: string = "";
  baggageCharge: number = 0;
}

export class SectorWiseMealProperties {
  meals: MealListAirArabia[] = [];
  fromCity: string = "";
  toCity: string = "";
}
export class MealListAirArabia {
  mealCode: string = "";
  mealDescription: string = "";
  mealCharge: string = "";
  mealName: string = "";
  mealImage: string = "";
  soldMeals: string = "";
  allocatedMeals: string = "";
  availableMeals: string = "";
}
export class TaxDetailsProperties {
  taxID: number;
  passengerID: number;
  taxType: string;
  taxAmount: number;
  refundTaxAmount: number;
  modifiedDateTime: Date;
  isDeleted: boolean;
  isRefund: boolean;
  refundID: number;
}

//export class BaggageDetails {
//  passengerType: string;
//  checkIn: number;
//  cabin: number;
//}
export class Remarks {
  text: string;
}
export class FileDownloadType {
  fullPath: string;
  fileExtension: string;
}
export class TravelPreference_ServiceType {
  serviceID: number;
  serviceItemType: string;
  status: boolean;
}
export class TravelPreference_MealList {
  mealID: number;
  mealList: string;
  status: boolean;
}
export class TravelPreference_SeatList {
  seatID: number;
  seatList: string;
  status: boolean;
}
export class PassengerCreationResponse {
  isSaved: boolean;
  bookingID: number;
  bookingDate: Date;
  errorInfo: string;
  airSegments: any[] = []
  airPricingSolution: any;
  airItienary: any;
  fareRules: any;
  isPriceChanged: boolean;
  isScheduleChanged: boolean;
  message: string;

}


export class GetAllBookingServicesProperties {
  serviceType: TravelPreference_ServiceType[] = [];
  mealList: TravelPreference_MealList[] = [];
  seatList: TravelPreference_SeatList[] = [];
}
export class EmailBookingProperties {
  customerEmail: string;
  subject: string;
  body: string;
  agencyId: string;
}

export class PassengerProfile {
  Profile_Id: number;
  Title: string = "";
  FirstName: string = "";
  LastName: string = "";

  PAXGender: string = "";
  paxDOB: string = "";
  Mobile_No: string = "";
  MobileSecondary: string = "";
  Phone_No: string = "";
  PassportValidFrom: string = "";
  PassportValidTo: string = "";
  PassportNumber: string = "";
  PassengerType: string = "";
  paxNationality: string = "";
  Email_Id: string = "";
  Frequent_Flyer_No: string = "";
  countryOfIssuance: string = "";
  passengerindex: number;
}
export class RemoveSectorProperties {
  fromAirport: string = "";
  toAirport: string = "";
  pnr_doc: string = "";

}
export class OfflineTicketIssuancePassenger {
  pnr: string = "";
  baseCurrency: string = "";
  bookingPccCode: string = "";
  supplierCode: string = "";
  exchangeCurrency: string = "";

}
export class PassengerIds {
  passengerId: number = 0;
  pnrDoc: string = "";
  firstName: string = "";
}
export class AddUpdateSectorInfoProperties {
  passengerIds: PassengerIds[] = [];
  sectorInfo: SectorInformationProperties[] = [];
}


export class OfflineTicketIssuancePassengerFares {
  serviceFeeAdult: number = 0;
  discountAdult: number = 0;
  markupAdult: number = 0;
  serviceFeeChild: number = 0;
  discountChild: number = 0;
  markupChild: number = 0;
  serviceFeeInfant: number = 0;
  discountInfant: number = 0;
  markupInfant: number = 0;
}
export class RemovePassengerData {
  BookingInfoProperties: BookingInfoProperties;
  RemovebookingPassengerInfo: BookingPassengerInfoProperties[] = []
}

export class UpdatePriceDetails {
  priceDetails: string;
  passengerFares: PassengerFares[] = [];
}
export class RateOfExchangeRequestProp {
  sectorInformation: SectorInformationProperties[] = [];
  supplierCode: string;
  supplierPccCode: string;
  flightProp: FlightSearchProperties;
}
export class RateOfExchangeResponse {
  appliedCriteria: string;
  exchangeValue: number = 1;
}



